import React, { useEffect, useState, useMemo } from 'react';
import api from '../services/api';
import { StockAuditBreakdownDialog, buildBreakdown } from '../pages/panels/StockAuditBreakdownDialog';

/**
 * ConsolidatedBreakdownDialog — parent-tab drill-down delegating to
 * the same `StockAuditBreakdownDialog` the child tabs use, so the
 * parent gets identical UX: subcategory groups + subtotals + search +
 * category/subcategory filters.
 *
 * The backend's /consolidated-breakdown endpoint emits `flat_rows` in
 * the exact shape of `estimated_receipts_breakdown` on a child
 * snapshot, with one row per (product × location) so the auditor can
 * see e.g. "Pimm's No.1 — Cellar" and "Pimm's No.1 — Main Bar" as
 * neighbouring rows under "Spirits", subtotaled by subcategory.
 *
 * iter439d (rewrite of iter439c).
 */
export const ConsolidatedBreakdownDialog = ({ open, onClose, parentSessionId, tile = 'estimated_receipts' }) => {
  const [synthCalc, setSynthCalc] = useState(null);

  useEffect(() => {
    if (!open || !parentSessionId) return;
    let cancelled = false;
    api.get(`/stocktake/multi-location/sessions/${parentSessionId}/consolidated-breakdown`, { params: { tile } })
      .then((res) => {
        if (cancelled) return;
        const d = res.data || {};
        setSynthCalc({
          estimated_receipts_breakdown: d.flat_rows || [],
          estimated_receipts_incl_vat: d.totals?.value_incl_vat,
          estimated_receipts_excl_vat: d.totals?.value_excl_vat,
        });
      })
      .catch(() => { if (!cancelled) setSynthCalc({ estimated_receipts_breakdown: [] }); });
    return () => { cancelled = true; };
  }, [open, parentSessionId, tile]);

  const breakdown = useMemo(() => {
    if (!synthCalc) return null;
    return buildBreakdown(tile, { calculation: synthCalc });
  }, [synthCalc, tile]);

  if (!open || !breakdown) return null;

  return (
    <StockAuditBreakdownDialog
      open={open}
      onClose={onClose}
      breakdown={{
        ...breakdown,
        title: 'Estimated Receipts — consolidated (all locations)',
      }}
    />
  );
};

export default ConsolidatedBreakdownDialog;
